import React, { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
var Form = function Form(_ref) {
  var methods = _ref.methods,
    onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    children = _ref.children,
    className = _ref.className,
    formRef = _ref.formRef,
    _ref$testAttribute = _ref.testAttribute,
    testAttribute = _ref$testAttribute === void 0 ? null : _ref$testAttribute;
  var _methods$formState = methods.formState,
    errors = _methods$formState.errors,
    isSubmitted = _methods$formState.isSubmitted,
    submitCount = _methods$formState.submitCount;
  useEffect(function () {
    if (!isSubmitted || Object.keys(errors).length === 0) {
      return;
    }
    var firstError = document.querySelector('form em.error');
    if (!firstError) {
      return;
    }
    var navBarHeight = document.querySelector('.fixed-top') ? document.querySelector('.fixed-top').clientHeight : 0;
    window.scroll(0, firstError.offsetTop - navBarHeight);
    var inputEl = firstError.parentNode.querySelector('input');
    if (inputEl) {
      inputEl.focus();
    }
  }, [submitCount]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(FormProvider, methods, /*#__PURE__*/React.createElement("form", {
      ref: formRef,
      className: className,
      onSubmit: methods.handleSubmit(onSubmit),
      onChange: onChange,
      "data-cy": testAttribute
    }, children))
  );
};
export default Form;